import { IconChevronRight, IconHome } from "@tabler/icons-react";

interface BreadcrumbProps {
  hierarchy: string[];
  onClick: (index: number) => void;
}

const textStyle = "group-hover:typography-small-base group-hover:text-text-base group-active:typography-small-strong group-active:text-text-base";
const iconStyle = "group-hover:text-icon-bg-base group-active:text-icon-bg-base";

const Breadcrumb = ({
  hierarchy, onClick,
}: BreadcrumbProps) => (
  <div className="flex gap-1">
    {hierarchy.map((item, index) => {
      const isLast = index === hierarchy.length - 1;
      return (
        <span key={index} className="flex items-center">
          <button className="flex gap-1 items-center group" disabled={isLast} type="button" onClick={() => onClick(index)}>
            {index === 0 && <IconHome className={`${hierarchy.length === 1 ? "text-icon-bg-base" : "text-icon-bg-subtle"} ${iconStyle}`} />}
            <span className={`${isLast ? "typography-small-strong text-text-base" : "typography-small-base text-text-subtle"} ${textStyle}`}>
              {item}
            </span>
          </button>
          {!isLast && <IconChevronRight className="text-icon-bg-subtle" />}
        </span>
      );
    })}
  </div>
);

export default Breadcrumb;
